import { render, staticRenderFns } from "./golddetail.vue?vue&type=template&id=3ee8c8d3&scoped=true"
import script from "./golddetail.vue?vue&type=script&lang=js"
export * from "./golddetail.vue?vue&type=script&lang=js"
import style0 from "./golddetail.vue?vue&type=style&index=0&id=3ee8c8d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee8c8d3",
  null
  
)

export default component.exports